import axios from "axios";
//import {browserHistory} from 'react-router';
const USER_INFORMATION_STORE_DATA = "editUserJobInformation/USER_INFORMATION_STORE_DATA";
const USER_DEPARTMENT_STORE_DATA ="editUserJobInformation/USER_DEPARTMENT_STORE_DATA";
const USER_JOB_STORE_DATA ="editUserJobInformation/USER_JOB_STORE_DATA";
const USER_JOB_INFORMATION_UPDATE="editUserJobInformation/USER_JOB_INFORMATION_UPDATE"
export const editUserJobInformation=(state= {
  loading: false,
  userJobName:"",
  userJobCode:"",
  userDepartmentName:"",
  userDepartmentCode:"",
  userCode:"",
  userWithEnterpriseId:"",
  editDepartment:[],
  editJob:[],
  },action)=>{
  switch (action.type){
    case  USER_INFORMATION_STORE_DATA:
      let newUser = {
        userJobName: action.data.content[0].position?.name,
        userJobCode: action.data.content[0].position?.code,
        userDepartmentName: action.data.content[0].department?.name,
        userDepartmentCode: action.data.content[0].department?.code,
        userCode: action.data.content[0].workNum,
        userWithEnterpriseId:action.data.content[0].id,
      };
      return {
        ...state,
        userJobName: newUser.userJobName,
        userJobCode: newUser.userJobCode,
        userDepartmentName:newUser.userDepartmentName,
        userDepartmentCode:newUser.userDepartmentCode,
        userCode:newUser.userCode,
        userWithEnterpriseId:newUser.userWithEnterpriseId
      };
    case  USER_DEPARTMENT_STORE_DATA:
      return {
        ...state,
        editDepartment: action.data
      };
    case USER_JOB_STORE_DATA:
      return{
        ...state,
        editJob: action.data
      };
    case USER_JOB_INFORMATION_UPDATE:
      return{
        ...state,
        [action.data.name]: action.data.value
      };
    default:
      return state
  }

}

/*获取用户信息*/
export const getUserInformation = (data) => {
  return {
    type: USER_INFORMATION_STORE_DATA,
    data: data
  }
};

/*获取下拉部门列表信息*/
export const getUserDepartmentInformation = (data) => {
  return {
    type: USER_DEPARTMENT_STORE_DATA ,
    data: data
  }
};

/*获取下拉岗位列表信息*/
export const getUserJobInformation = (data) => {
  return {
    type: USER_JOB_STORE_DATA ,
    data: data
  }
};
export const updateUserJobInformationData = (data) => {
  return {
    type: USER_JOB_INFORMATION_UPDATE,
    data: data
  }
};

export const getEditUserInformation= (id,name) => (dispatch) => {
  let url = "/api-user/userWithEnterprises?enterpriseId=" + id+ "&username="+name+"&pageNumber=0&pageSize=1&type=1";
  axios.get(url, {contentType: "application/json"}).then(
    response => {
      if (response.status === 200) {
        if(response.data.content!==0) {
          dispatch(getUserInformation(response.data));
          dispatch(getUserDepartmentData(id));
          dispatch(getDepartmentJobs(response.data.content[0].department?.id));
        }
      }
    }
  )
};

export const getUserDepartmentData=(data)=>(dispatch)=>{
  let url="/api-user/getDepartments?enterpriseId="+ data;
  axios(url).then(response=>{
    if(response.data){
      dispatch(getUserDepartmentInformation(response.data));
    }
  })

};


export const getDepartmentJobs = (departmentId) => (dispatch) => {
  if(!!departmentId) {
    let url = `/api-user/mainData/getDepartmentPositions?departmentId=${departmentId}`;
    axios(url).then(response => {
      if (response.data) {
        dispatch(getUserJobInformation(response.data));
      }
    })
  }else {
    dispatch(getUserJobInformation([]));
  }
}
